import React from 'react';
import { Title, Box, Button, Flex, Anchor } from '@mantine/core';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { formatPrice } from '@/utils/utilities';
import { creatorActions } from '@/store/slices/creatorSlice';
import { Collections } from './steps/Collections';
import { Configuration } from './steps/Configuration';
import { useUpdateProject } from '@/hooks/useUpdateProject';
import { ContactFormButton } from '@/components/ui/contactFormButton/ContactFormButton';
import { useContent } from '@/providers/ContentProvider';
import styles from './Aside.module.scss';

const baseSlug = 'aside.';

export const Aside: React.FC = () => {
	const dispatch = useTypedDispatch();

	const { getContent } = useContent();

	useUpdateProject();

	const { options, project, selectedProductModuleCollection } =
		useTypedSelector((state) => state.creator);

	const handleOpenSummary = () => {
		dispatch(creatorActions.updateOptions({ summaryDrawerOpened: true }));
	};

	const handleOpenDownloadModel = () => {
		dispatch(creatorActions.updateOptions({ downloadDrawerOpened: true }));
	};

	return (
		<Box
			component="aside"
			className={styles.container}
			id="creator-aside"
			pb="md"
			px={{ base: 'md', md: 'lg' }}
		>
			<Title order={2} mb="lg" pt="md" className={styles.title}>
				{getContent(`${baseSlug}totalPrice`, {
					vars: {
						$price: formatPrice(project ? project.price / 100 : 0, {
							currencyDisplay: 'symbol',
						}),
					},
				})}
			</Title>
			<Collections />
			<Configuration />
			{!!selectedProductModuleCollection && (
				<Box mt="auto">
					{!options.isPresetMode && (
						<Flex justify="space-between" mb="sm">
							<Anchor underline="always" onClick={handleOpenSummary}>
								{getContent(`${baseSlug}viewSummary`)}
							</Anchor>
							<Anchor underline="always" onClick={handleOpenDownloadModel}>
								{getContent(`${baseSlug}downloadConfiguration`)}
							</Anchor>
						</Flex>
					)}
					{!options.isPreviewMode && (
						<>
							<Flex justify="space-between" mb="sm">
								{!options.isPresetMode && (
									<Button size="lg" color="black" type="submit" fullWidth>
										{getContent(`${baseSlug}addToCart`)}
									</Button>
								)}
								{options.isPresetMode && (
									<Button size="lg" color="black" type="submit" fullWidth>
										{getContent(`${baseSlug}savePreset`)}
									</Button>
								)}
							</Flex>
							{!options.isPresetMode && (
								<ContactFormButton fullWidth variant="outline" />
							)}
						</>
					)}
				</Box>
			)}
		</Box>
	);
};
